<template>
  <div class="modalContents__object11">
    <div class="container">
      <div class="row no-gutters">
        <div class="col-xl-6 col-lg-8 col-md-11 col-12 mx-auto">
          <h2 class="text-center">CONTACT US</h2>
          <form class="row no-gutters">
            <div class="modalContents__object11__btn">
              <a href="javascript:void(0)" class="globalModal--btn" title="close" @click="hideModal">
                <span class="fa-stack fa-lg">
                  <i class="fa fa-circle-thin fa-stack-2x fa-inverse" aria-hidden="true"></i>
                  <i class="fa fa-times fa-stack-1x fa-inverse" aria-hidden="true"></i>
                </span>
              </a>
            </div>
            <h3 class="col-10 mr-auto">■ お問い合わせ</h3>
            <!-- お名前 -->
            <div class="col-6 modalContents__object11--position01">
              <label for="your-name">姓（※必須）</label>
              <input
                type="text"
                name="your-name"
                id="constact-your-name"
                class="form-control"
                placeholder="姓（※必須）"
                v-model="your_name"
                v-on:blur="check_your_name()"
              >
              <p v-if="errors.your_name" class="error_message text-danger">{{ errors.your_name }}</p>
            </div>
            <div class="col-6 modalContents__object11--position02">
              <label for="your-name2">名（※必須）</label>
              <input
                type="text"
                name="your-name2"
                id="constact-your-name2"
                class="form-control"
                placeholder="名（※必須）"
                v-model="your_name2"
                v-on:blur="check_your_name2()"
              >
              <p v-if="errors.your_name2" class="error_message text-danger">{{ errors.your_name2 }}</p>
            </div>
            <!-- メール -->
            <div class="col-12">
              <label for="your-email">メールアドレス（※必須）</label>
              <input
                type="email"
                name="your-email"
                id="constact-your-email"
                class="form-control"
                placeholder="MAIL ADDRESS"
                v-model="your_email"
                v-on:blur="check_your_email()"
              >
              <p v-if="errors.your_email" class="error_message text-danger">{{ errors.your_email }}</p>
            </div>
            <!-- 電話 -->
            <div class="col-12">
              <label for="your-tel">電話番号（ハイフン「-」不要）</label>
              <input
                type="tel"
                name="your-tel"
                id="constact-your-tel"
                class="form-control"
                placeholder="TEL"
                v-model="your_tel"
                v-on:blur="check_your_tel()"
              >
              <p v-if="errors.your_tel" class="error_message text-danger">{{ errors.your_tel }}</p>
            </div>
            <!-- お問い合わせ項目 -->
            <div class="col-12 row no-gutters">
              <label for="select" class="col-12">お問い合わせ項目</label>
              <div class="col-sm-8 modalContents__object11--position03">
                <div class="modalContents__object11--select">
                  <select name="select" id="constact-select" class="form-control" v-model="your_select" v-on:change="check_your_select">
                    <option value selected>選択してください</option>
                    <option value="会員登録について">会員登録について</option>
                    <option value="境界なき記者団について">境界なき記者団について</option>
                    <option value="ニューズオプエドについて">ニューズオプエドについて</option>
                    <option value="取材・インタビュー依頼">取材・インタビュー依頼</option>
                    <option value="スポーツ生中継について">スポーツ生中継について</option>
                    <option value="広告出稿について">広告出稿について</option>
                    <option value="運営会社について">運営会社について</option>
                    <option value="その他">その他</option>
                  </select>
                  <p v-if="errors.your_select" class="error_message text-danger">{{ errors.your_select }}</p>
                </div>
              </div>
            </div>
            <!-- お問い合わせ内容 -->
            <div class="col-12">
              <label for="textarea">お問い合わせ内容（※必須）</label>
              <textarea
                class="form-control"
                id="constact-textarea"
                rows="10"
                placeholder="お問い合わせ内容（1000文字以内）"
                v-model="your_content"
                v-on:blur="check_your_content()"
              ></textarea>
              <p v-if="errors.your_content" class="error_message text-danger">{{ errors.your_content }}</p>
            </div>

            <!-- <p>電話でのお問い合わせ
              <a href="tel:03-6721-1468">03-6721-1468</a> 受付時間（平日午前10時〜午後5時）
            </p> -->
            <p>お問い合わせの回答にお時間をいただくことがあります。予めご了承ください。</p>
            <!-- 次へボタン -->
            <div class="col-6 offset-6 modalContents__object11--position02">
              <button class="text-center btn" id="contact-submit" v-on:click="contact_submit">送信</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .error_message{
    font-size: 85%;
    padding-top: 6px;
    margin-bottom: 0;
  }
</style>


<script>
  import MultiModalMixin from '../mixins/ModalMixin'

export default {
  name: "Contact",
  data: function(){
    return {
      your_name: '',
      your_name2: '',
      your_email: '',
      your_tel: '',
      your_select: '',
      your_content: '',
      errors : {
        your_name : '',
        your_name2 : '',
        your_email : '',
        your_tel : '',
        your_select : '',
        your_content : '',
      }
    }
  },
  methods: {
    check_your_name () {
      if(this.your_name == ''){
        this.errors.your_name = '姓は必ずご入力ください';
      }else{
        this.errors.your_name = '';
      }
    },
    check_your_name2 () {
      if(this.your_name2 == ''){
        this.errors.your_name2 = '名は必ずご入力ください';
      }else{
        this.errors.your_name2 = '';
      }
    },
    check_your_tel () {
      if(this.your_tel == ''){
        this.errors.your_tel = '電話番号は必ずご入力ください';
      }else{
        this.errors.your_tel = '';
      }
    },
    check_your_select () {
      if(this.your_select == ''){
        this.errors.your_select = 'お問い合わせ項目は必ずご選択ください';
      }else{
        this.errors.your_select = '';
      }
    },
    check_your_email () {
      if(this.your_email == ''){
        this.errors.your_email = 'メールアドレスは必ずご入力ください';
      }else{
        if(this.validEmail(this.your_email)){
          this.errors.your_email = '';
        }else{
          this.errors.your_email = '正しいメールアドレスをご入力ください';
        }
      }
    },
    validEmail: function (email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    check_your_content () {
      if(this.your_content == ''){
        this.errors.your_content = 'お問い合わせ内容は必ずご入力ください';
      }else{
        this.errors.your_content = '';
      }
    },
    contact_submit (e) {
      this.check_your_name();
      this.check_your_name2();
      this.check_your_email();
      this.check_your_tel();
      this.check_your_select();
      this.check_your_content();
      if(!this.hasError()){
        var params = {
          last_name : this.your_name,
          first_name : this.your_name2,
          email : this.your_email,
          tel : this.your_tel,
          select : this.your_select,
          textarea : this.your_content,
        }
        axios
          .post('/contact',params)
          .then(response => {
            if(response.status == 200){
              // 送信完了
              console.log('contact submited')
            }
          })
          .catch(error => console.log(error))

        this.showModalContactThanks();
      }
      e.preventDefault();
    },
    hasError(){
      var isError = false;
      for(var err in this.errors){
        if(this.errors[err]){
          isError = true;
        }
      }
      return isError;
    },
  },
  mixins: [MultiModalMixin],
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/vue/component/modal/contact.vue